import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { observable, runInAction } from 'mobx';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
import { WindowItemLayer } from '../../transportLayers/window/WindowItemLayer';
/** Persistent store for WindowItems */

export var WindowItemStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(WindowItemStore, _BaseStore);

  function WindowItemStore() {
    var _this;

    _classCallCheck(this, WindowItemStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemStore).apply(this, arguments));
    _this.name = StoreName.WindowItem;
    _this.windowItemLayer = new WindowItemLayer();
    _this.list = new Map();
    return _this;
  }

  _createClass(WindowItemStore, [{
    key: "getItemsByWindowId",
    value: function getItemsByWindowId(windowId, sessionId) {
      var _this2 = this;

      return this.windowItemLayer.getItemsByWindowId(windowId, sessionId).then(function (windowItems) {
        runInAction(function () {
          _this2.list.clear();

          windowItems.forEach(function (windowItem) {
            _this2.list.set(windowItem.id, windowItem);
          });
        });
        return _this2.list;
      });
    }
  }, {
    key: "createWindowItem",
    value: function createWindowItem(windowId, productIds, sessionId) {
      var _this3 = this;

      return this.windowItemLayer.createWindowItems(windowId, productIds, sessionId).then(function (windowItems) {
        runInAction(function () {
          _this3.list.clear();

          windowItems.forEach(function (windowItem) {
            _this3.list.set(windowItem.id, windowItem);
          });
        });
        return _this3.list;
      });
    }
  }]);

  return WindowItemStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], WindowItemStore.prototype, "list", void 0);